import {USERS_DASHBOARD, SETTING, MY_PAGE, LOG_OUT, CHANGE_PASSWORD} from "../../constants/routes";
import HeaderMenuItem from "./HeaderMenuItem";
import {isMasterAdmin, isSuperAdmin} from "../../utils/authentication-utils";
import store from "../../store";

const HeaderTenkenMenu = () => {
  const auth = store.getState().auth;
  const notifications = auth.notifications;
  const hasNotifications = (notifications?.total_unread && notifications?.total_unread > 0);
  const profileSubMenu = [
    {"icon": "header-my-page", "menu": "マイページ", "link": MY_PAGE, "number": getQuantityNotificationsDisplay(notifications?.total_unread)},
    {"icon": "header-change-password", "menu": "パスワード変更", "link": CHANGE_PASSWORD},
    {"icon": "header-logout", "menu": "ログアウト", "link": LOG_OUT},
  ];
  return (
    <div className="flex flex-row items-center space-x-4">
      {(isSuperAdmin() || isMasterAdmin()) && <HeaderMenuItem icon="header-user" menu="ユーザー管理" link={USERS_DASHBOARD}/>}
      {isSuperAdmin() && <HeaderMenuItem icon="header-setting" menu="システム設定" link={SETTING}/>}
      <HeaderMenuItem icon="header-profile" menu={auth.user.name} subMenuItems={profileSubMenu} hasNotifications={hasNotifications}/>
    </div>
  );
};

const getQuantityNotificationsDisplay = (notifications) => {
  if (!notifications) {
    return '';
  }

  if (notifications === 0) return '';
  if (notifications > 99) return '99+';
  return notifications.toString();
};

export default HeaderTenkenMenu;